export default __webpack_public_path__ + "static/media/iPadSS4.2808bb0a.png";